import React, { useState } from 'react';
import { Carousel } from 'react-bootstrap';
import { BsCircleFill } from 'react-icons/bs';

import Slide1 from 'src/assets/images/slide1.svg';
import Slide2 from 'src/assets/images/slide2.svg';
import Slide3 from 'src/assets/images/slide3.svg';

const LayoutCarousel = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex: number) => {
    setIndex(selectedIndex);
  };

  return (
    <>
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        interval={5000}
        indicators={false}
        controls={false}
        pauseOnHover={false}
      >
        <Carousel.Item>
          <img className={`mw-100 w-100`} src={Slide1} alt="First slide" />
          <div>
            <h4 className="text-primary font-weight-bold mt-3">Welcome to Open Rewards</h4>
            <p className="text-muted">
              THANK YOU, to all of you for supporting out local businesses. We are so glad you are here.
            </p>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <img className={`mw-100 w-100`} src={Slide2} alt="Second slide" />

          <div>
            <h4 className="text-primary font-weight-bold mt-3">Earn when shopping local</h4>
            <p className="text-muted">Get 5% back when shopping local in your community.</p>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <img className={`mw-100 w-100`} src={Slide3} alt="Third slide" />

          <div>
            <h4 className="text-primary font-weight-bold mt-3">Redeem in your community</h4>
            <p className="text-muted">Use your credit at any other businesses in your community.</p>
          </div>
        </Carousel.Item>
      </Carousel>
      <SliderIndicators steps={3} activeStep={index} />
    </>
  );
};

export default LayoutCarousel;

export const SliderIndicators: React.FunctionComponent<{ steps: number; activeStep: number }> = ({
  steps,
  activeStep,
}) => {
  const slides = new Array(steps);

  return (
    <div className="d-flex justify-content-center">
      <div className="d-flex border rounded-pill p-1 px-2" style={{ boxShadow: '0px 4px 4px 0px #ababab' }}>
        {slides.fill('').map((key: string, index: number) => (
          <div className={`d-flex ${index === slides.length - 1 ? '' : 'mr-2'}`} key={key}>
            <BsCircleFill className={index === activeStep ? 'royal-blue-color' : 'icon-light-grey'} size="7px" />
          </div>
        ))}
      </div>
    </div>
  );
};
